import { render, staticRenderFns } from "./ResetPasswordFirstAccess.vue?vue&type=template&id=12007a21&"
import script from "./ResetPasswordFirstAccess.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordFirstAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports